module.exports = __webpack_public_path__ + "img/wondercelt_tech_Normal_ua.1675727b.webp";